import { Box, CircularProgress } from '@mui/material';

export const OnboardingLoading: React.FC = () => (
  <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
    <CircularProgress />
  </Box>
);
